import { render, staticRenderFns } from "./ConfigurationPage.vue?vue&type=template&id=13f23f4e&scoped=true&"
import script from "./ConfigurationPage.vue?vue&type=script&lang=js&"
export * from "./ConfigurationPage.vue?vue&type=script&lang=js&"
import style0 from "./ConfigurationPage.vue?vue&type=style&index=0&id=13f23f4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f23f4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f23f4e')) {
      api.createRecord('13f23f4e', component.options)
    } else {
      api.reload('13f23f4e', component.options)
    }
    module.hot.accept("./ConfigurationPage.vue?vue&type=template&id=13f23f4e&scoped=true&", function () {
      api.rerender('13f23f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/settingsPage/ConfigurationPage.vue"
export default component.exports